import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ceo-suite")({
  beforeLoad: () => {
    throw redirect({ to: "/" });
  },
  head: () => ({
    meta: [
      { title: "Tables and Bridges" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
